import React from 'react';
import { Badge } from '../ui/badge';
import BillableBadge from './BillableBadge';

const ResultsDropdown = ({ results, onSelect, testId }) => (
  <div
    className="border rounded-lg max-h-56 overflow-y-auto bg-white shadow-lg z-50 relative"
    data-testid={`${testId}-results`}
  >
    {results.map((code) => (
      <div
        key={code.code}
        className="flex items-center gap-2 px-3 py-2.5 hover:bg-slate-50 cursor-pointer border-b last:border-b-0 transition-colors"
        onClick={() => onSelect(code)}
        data-testid={`${testId}-option-${code.code}`}
      >
        <Badge
          variant="outline"
          className={`font-mono text-xs shrink-0 ${
            code.billable
              ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
              : 'bg-amber-50 text-amber-700 border-amber-200'
          }`}
        >
          {code.code}
        </Badge>
        <span className="text-sm text-slate-700 flex-1 truncate">
          {code.description}
        </span>
        <BillableBadge code={code.code} billable={code.billable} compact />
      </div>
    ))}
  </div>
);

export default ResultsDropdown;
